import React from 'react'

import {
  Box,
  Button,
  ChartAreaIcon,
  ExpansionPanelProps,
  InfoCardList,
  SidebarExpansionPanel,
  useModal,
} from '@forgeglobal/design-framework'

import { CreateHoldingModal } from 'components/holdings/CreateHoldingModal'
import { LinkTo, transformHoldingFragment } from 'components/holdings/HoldingUtils'
import { useAccountHoldingsQuery } from 'graphql/bindings/AdminBindings'

interface PortfolioSidebarPanelProps extends Omit<ExpansionPanelProps, 'children'> {
  accountId: string
}

const PortfolioSidebarPanel: React.FC<PortfolioSidebarPanelProps> = ({ accountId, ...props }) => {
  const { data } = useAccountHoldingsQuery({ variables: { accountId: accountId } })
  const holdings = data?.account?.holdings ?? []
  const dataList = holdings.map(holding => transformHoldingFragment(holding, false, LinkTo.Issuer))
  const holdingAccount = {
    accountId: accountId,
    accountName: data?.account?.name ?? '',
  }
  const [openCreateHoldingModal, hideCreateHoldingModal] = useModal(() => {
    return <CreateHoldingModal hideModal={hideCreateHoldingModal} fromAccount={holdingAccount || undefined} />
  }, [holdingAccount])

  return (
    <SidebarExpansionPanel icon={<ChartAreaIcon />} title="Portfolio" {...props}>
      <Button onClick={openCreateHoldingModal} fullWidth>
        Create Holding
      </Button>
      {!!dataList.length && (
        <Box mt={2}>
          <InfoCardList items={dataList} />
        </Box>
      )}
    </SidebarExpansionPanel>
  )
}

export { PortfolioSidebarPanel }
